var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 32,
    viewBox: "0 0 112 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.936 32H4.3721C2.11671 32 0.269531 30.199 0.269531 28V4C0.269531 1.801 2.11671 1.90735e-06 4.3721 1.90735e-06H106.936C109.192 1.90735e-06 111.039 1.801 111.039 4V28C111.039 30.199 109.192 32 106.936 32Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.936 0.641C108.836 0.641 110.381 2.148 110.381 4V28C110.381 29.852 108.836 31.359 106.936 31.359H4.3721C2.47261 31.359 0.926967 29.852 0.926967 28V4C0.926967 2.148 2.47261 0.641 4.3721 0.641H106.936ZM106.936 1.90735e-06H4.3721C2.11671 1.90735e-06 0.269531 1.801 0.269531 4V28C0.269531 30.199 2.11671 32 4.3721 32H106.936C109.192 32 111.039 30.199 111.039 28V4C111.039 1.801 109.192 1.90735e-06 106.936 1.90735e-06Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82973 6.03085C8.58871 6.27685 8.44922 6.65985 8.44922 7.15585V24.8479C8.44922 25.3439 8.58871 25.7269 8.82973 25.9729L8.88922 26.0269L19.0574 16.1169V15.8829L8.88922 5.97285L8.82973 6.03085Z",
    fill: "url(#paint0_linear_15530_16111)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4442 19.4219L19.0586 16.1169V15.8829L22.4483 12.5779L22.5242 12.6209L26.5386 14.8479C27.6842 15.4799 27.6842 16.5199 26.5386 17.1559L22.5242 19.3789L22.4442 19.4219Z",
    fill: "url(#paint1_linear_15530_16111)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5215 19.379L19.0558 16L8.82812 25.973C9.20864 26.363 9.82915 26.41 10.5348 26.02L22.5215 19.379Z",
    fill: "url(#paint2_linear_15530_16111)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5215 12.621L10.5348 5.98C9.82915 5.594 9.20864 5.641 8.82812 6.031L19.0558 16L22.5215 12.621Z",
    fill: "url(#paint3_linear_15530_16111)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1756 8.1947C39.1756 8.8627 38.9705 9.3977 38.5664 9.7967C38.1018 10.2697 37.4967 10.5077 36.7551 10.5077C36.0464 10.5077 35.4413 10.2657 34.9449 9.7887C34.4474 9.3047 34.1992 8.7107 34.1992 7.9997C34.1992 7.2887 34.4474 6.6947 34.9449 6.2147C35.4413 5.7337 36.0464 5.4917 36.7551 5.4917C37.1079 5.4917 37.4443 5.5627 37.7654 5.6947C38.0854 5.8277 38.3459 6.0077 38.5346 6.2297L38.1059 6.6517C37.7767 6.2727 37.3285 6.0857 36.7551 6.0857C36.2382 6.0857 35.79 6.2617 35.4095 6.6167C35.0331 6.9727 34.8443 7.4337 34.8443 7.9997C34.8443 8.5657 35.0331 9.0307 35.4095 9.3867C35.79 9.7377 36.2382 9.9177 36.7551 9.9177C37.3038 9.9177 37.7654 9.7377 38.1295 9.3827C38.3695 9.1477 38.5059 8.8237 38.5418 8.4097H36.7551V7.8317H39.1387C39.1674 7.9567 39.1756 8.0777 39.1756 8.1947Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9588 6.19105H40.7198V7.71105H42.7382V8.28905H40.7198V9.80905H42.9588V10.398H40.0859V5.60205H42.9588V6.19105Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6244 10.398H44.9905V6.19105H43.6172V5.60205H46.9987V6.19105H45.6244V10.398Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4492 10.398V5.60205H50.082V10.398H49.4492Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8861 10.398H52.2574V6.19105H50.8789V5.60205H54.2645V6.19105H52.8861V10.398Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6674 9.7807C60.1823 10.2657 59.5813 10.5077 58.8643 10.5077C58.1433 10.5077 57.5423 10.2657 57.0572 9.7807C56.5731 9.2967 56.332 8.7027 56.332 7.9997C56.332 7.2967 56.5731 6.7027 57.0572 6.2187C57.5423 5.7337 58.1433 5.4917 58.8643 5.4917C59.5772 5.4917 60.1782 5.7337 60.6633 6.2227C61.1515 6.7107 61.3925 7.3007 61.3925 7.9997C61.3925 8.7027 61.1515 9.2967 60.6674 9.7807ZM57.5259 9.3787C57.891 9.7377 58.3351 9.9177 58.8643 9.9177C59.3895 9.9177 59.8377 9.7377 60.1987 9.3787C60.5628 9.0197 60.7474 8.5587 60.7474 7.9997C60.7474 7.4407 60.5628 6.9797 60.1987 6.6207C59.8377 6.2617 59.3895 6.0817 58.8643 6.0817C58.3351 6.0817 57.891 6.2617 57.5259 6.6207C57.1618 6.9797 56.9772 7.4407 56.9772 7.9997C56.9772 8.5587 57.1618 9.0197 57.5259 9.3787Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2812 10.398V5.60205H63.0505L65.4423 9.33205H65.47L65.4423 8.41005V5.60205H66.0751V10.398H65.4146L62.91 6.48405H62.8823L62.91 7.41005V10.398H62.2812Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1771 17.4022C54.2499 17.4022 52.6756 18.8322 52.6756 20.8052C52.6756 22.7622 54.2499 24.2072 56.1771 24.2072C58.1084 24.2072 59.6827 22.7622 59.6827 20.8052C59.6827 18.8322 58.1084 17.4022 56.1771 17.4022ZM56.1771 22.8672C55.1197 22.8672 54.2099 22.0162 54.2099 20.8052C54.2099 19.5782 55.1197 18.7422 56.1771 18.7422C57.2345 18.7422 58.1484 19.5782 58.1484 20.8052C58.1484 22.0162 57.2345 22.8672 56.1771 22.8672ZM48.5371 17.4022C46.6058 17.4022 45.0356 18.8322 45.0356 20.8052C45.0356 22.7622 46.6058 24.2072 48.5371 24.2072C50.4674 24.2072 52.0386 22.7622 52.0386 20.8052C52.0386 18.8322 50.4674 17.4022 48.5371 17.4022ZM48.5371 22.8672C47.4786 22.8672 46.5658 22.0162 46.5658 20.8052C46.5658 19.5782 47.4786 18.7422 48.5371 18.7422C49.5945 18.7422 50.5043 19.5782 50.5043 20.8052C50.5043 22.0162 49.5945 22.8672 48.5371 22.8672ZM39.4458 18.4452V19.8912H42.9874C42.8838 20.6992 42.6068 21.2932 42.1822 21.7072C41.6653 22.2072 40.8602 22.7622 39.4458 22.7622C37.2663 22.7622 35.5597 21.0472 35.5597 18.9222C35.5597 16.7972 37.2663 15.0822 39.4458 15.0822C40.6243 15.0822 41.4817 15.5312 42.1145 16.1132L43.1597 15.0942C42.2745 14.2702 41.0971 13.6372 39.4458 13.6372C36.4571 13.6372 33.9453 16.0082 33.9453 18.9222C33.9453 21.8362 36.4571 24.2072 39.4458 24.2072C41.0612 24.2072 42.2745 23.6912 43.2284 22.7232C44.2058 21.7702 44.5104 20.4302 44.5104 19.3482C44.5104 19.0122 44.4817 18.7032 44.4304 18.4452H39.4458ZM76.6212 19.5662C76.333 18.8052 75.4438 17.4022 73.6325 17.4022C71.8376 17.4022 70.3433 18.7812 70.3433 20.8052C70.3433 22.7112 71.8222 24.2072 73.8048 24.2072C75.4079 24.2072 76.333 23.2542 76.7135 22.6992L75.5238 21.9262C75.1268 22.4922 74.5863 22.8672 73.8048 22.8672C73.0284 22.8672 72.4715 22.5202 72.1145 21.8362L76.7822 19.9532L76.6212 19.5662ZM71.8622 20.6992C71.8222 19.3872 72.9074 18.7152 73.6848 18.7152C74.294 18.7152 74.8109 19.0122 74.9833 19.4372L71.8622 20.6992ZM68.0684 24.0002H69.6027V14.0002H68.0684V24.0002ZM65.5556 18.1602H65.5043C65.1597 17.7622 64.5022 17.4022 63.6694 17.4022C61.9217 17.4022 60.3238 18.8982 60.3238 20.8162C60.3238 22.7232 61.9217 24.2072 63.6694 24.2072C64.5022 24.2072 65.1597 23.8442 65.5043 23.4342H65.5556V23.9222C65.5556 25.2232 64.8427 25.9222 63.693 25.9222C62.7556 25.9222 62.174 25.2622 61.934 24.7072L60.5997 25.2502C60.9843 26.1522 62.0027 27.2622 63.693 27.2622C65.492 27.2622 67.0099 26.2302 67.0099 23.7192V17.6092H65.5556V18.1602ZM63.8007 22.8672C62.7433 22.8672 61.8581 22.0042 61.8581 20.8162C61.8581 19.6172 62.7433 18.7422 63.8007 18.7422C64.8427 18.7422 65.6643 19.6172 65.6643 20.8162C65.6643 22.0042 64.8427 22.8672 63.8007 22.8672ZM83.8048 14.0002H80.135V24.0002H81.6653V20.2112H83.8048C85.5043 20.2112 87.1709 19.0122 87.1709 17.1052C87.1709 15.1992 85.5002 14.0002 83.8048 14.0002ZM83.8448 18.8202H81.6653V15.3912H83.8448C84.9874 15.3912 85.6397 16.3162 85.6397 17.1052C85.6397 17.8792 84.9874 18.8202 83.8448 18.8202ZM93.3043 17.3832C92.1986 17.3832 91.0489 17.8592 90.5761 18.9142L91.934 19.4692C92.2263 18.9142 92.7638 18.7342 93.332 18.7342C94.1258 18.7342 94.9309 19.1992 94.9433 20.0202V20.1252C94.6663 19.9692 94.0735 19.7382 93.3443 19.7382C91.8817 19.7382 90.3915 20.5232 90.3915 21.9882C90.3915 23.3282 91.5894 24.1912 92.9361 24.1912C93.9658 24.1912 94.534 23.7382 94.8909 23.2112H94.9433V23.9842H96.4212V20.1482C96.4212 18.3752 95.0633 17.3832 93.3043 17.3832ZM93.1197 22.8632C92.6192 22.8632 91.9217 22.6212 91.9217 22.0162C91.9217 21.2422 92.7915 20.9452 93.5443 20.9452C94.2181 20.9452 94.534 21.0902 94.9433 21.2812C94.8233 22.2072 94.0058 22.8632 93.1197 22.8632ZM101.806 17.6022L100.047 21.9372H99.9945L98.1761 17.6022H96.5258L99.2581 23.6602L97.6991 27.0312H99.2981L103.508 17.6022H101.806ZM88.012 24.0002H89.5463V14.0002H88.012V24.0002Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15530_16111",
    x1: 18.1546,
    y1: 25.0321,
    x2: 4.73299,
    y2: 11.2663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15530_16111",
    x1: 28.0304,
    y1: 15.9988,
    x2: 8.17654,
    y2: 15.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15530_16111",
    x1: 20.6369,
    y1: 14.1631,
    x2: 2.43614,
    y2: -4.50439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15530_16111",
    x1: 6.2536,
    y1: 31.859,
    x2: 14.3811,
    y2: 23.5232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.d58c052c65cf6b53c9b5221f6325cf71.svg";
export { ForwardRef as ReactComponent };